import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from '@phosphor-icons/react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-background mt-24 topo-bg bg-blend-multiply">
      <div className="bg-foreground/90">
        <div className="container py-16 grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-accent flex items-center justify-center rounded-sm">
                <Shield weight="duotone" size={22} />
              </div>
              <div className="font-display font-black text-lg">jouw noodpakket<span className="text-accent">.nl</span></div>
            </div>
            <p className="text-sm text-background/70 leading-relaxed">
              Onafhankelijk Nederlands platform voor noodpakketten. Wij vergelijken, adviseren en linken door naar betrouwbare shops.
            </p>
          </div>
          <div>
            <div className="overline text-background/60 mb-3">Ontdek</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/noodsituaties" className="hover:text-accent">Noodsituaties</Link></li>
              <li><Link to="/categorieen" className="hover:text-accent">Categorieën</Link></li>
              <li><Link to="/beste-keuzes" className="hover:text-accent">Beste keuzes 2026</Link></li>
              <li><Link to="/wizard" className="hover:text-accent">Pakket-wizard</Link></li>
              <li><Link to="/gids" className="hover:text-accent">Gids & artikelen</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-background/60 mb-3">Info</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/over-ons" className="hover:text-accent">Over ons</Link></li>
              <li><Link to="/over-ons#disclaimer" className="hover:text-accent">Disclaimer</Link></li>
              <li><a href="https://www.rijksoverheid.nl/onderwerpen/rampen-en-crises/noodpakket" target="_blank" rel="noreferrer" className="hover:text-accent">Rijksoverheid advies</a></li>
            </ul>
          </div>
          <div>
            <div className="overline text-background/60 mb-3">Belangrijk</div>
            <p className="text-xs text-background/60 leading-relaxed">
              Links op deze website kunnen affiliate-links zijn. Wanneer je iets koopt via een link, ontvangen wij mogelijk een kleine commissie — voor jou verandert de prijs niet.
            </p>
          </div>
        </div>
        <div className="border-t border-background/10">
          <div className="container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-background/60">
            <div>© {new Date().getFullYear()} Jouw Noodpakket.nl — alle rechten voorbehouden.</div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-accent rounded-full animate-pulse" />
              <span>In nood bel altijd <strong className="text-background">112</strong></span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
